/*
Drosera
*/
export function initDrosera() {
	// ===== Particle System (floating bog spores) =====
	const canvas = document.getElementById("particles");
	const ctx = canvas.getContext("2d");
	let W,
		H,
		particles = [];

	function resize() {
		W = canvas.width = window.innerWidth;
		H = canvas.height = window.innerHeight;
	}
	resize();
	window.addEventListener("resize", resize);

	function Particle() {
		this.reset = function () {
			this.x = Math.random() * W;
			this.y = H + 10;
			this.r = Math.random() * 1.8 + 0.3;
			this.speed = Math.random() * 0.4 + 0.1;
			this.drift = (Math.random() - 0.5) * 0.3;
			this.opacity = Math.random() * 0.4 + 0.1;
			this.wobble = Math.random() * Math.PI * 2;
			this.wobbleSpeed = Math.random() * 0.02 + 0.005;
		};
		this.reset();
		this.y = Math.random() * H;
	}

	for (let i = 0; i < 60; i++) particles.push(new Particle());

	let mouseX = -999,
		mouseY = -999;
	document.addEventListener("mousemove", (e) => {
		mouseX = e.clientX;
		mouseY = e.clientY;
	});

	function animate() {
		ctx.clearRect(0, 0, W, H);
		particles.forEach((p) => {
			p.wobble += p.wobbleSpeed;
			p.x += p.drift + Math.sin(p.wobble) * 0.3;
			p.y -= p.speed;

			// Gentle mouse repulsion
			const dx = p.x - mouseX,
				dy = p.y - mouseY;
			const dist = Math.sqrt(dx * dx + dy * dy);
			if (dist < 80) {
				p.x += (dx / dist) * 0.8;
				p.y += (dy / dist) * 0.5;
			}

			if (p.y < -10) p.reset();

			ctx.beginPath();
			ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
			ctx.fillStyle = `rgba(168, 201, 127, ${p.opacity})`;
			ctx.fill();
		});
		requestAnimationFrame(animate);
	}
	animate();

	// ===== Custom cursor =====
	const cursor = document.getElementById("cursor");
	let cx = 0,
		cy = 0,
		tx = 0,
		ty = 0;

	document.addEventListener("mousemove", (e) => {
		tx = e.clientX;
		ty = e.clientY;
		cursor.style.opacity = "1";
	});

	document.addEventListener("mouseleave", () => (cursor.style.opacity = "0"));

	function animateCursor() {
		cx += (tx - cx) * 0.12;
		cy += (ty - cy) * 0.12;
		cursor.style.left = cx + "px";
		cursor.style.top = cy + "px";
		requestAnimationFrame(animateCursor);
	}
	animateCursor();

	// ===== Reveal on scroll =====
	const revealEls = document.querySelectorAll(
		".reveal, .reveal-left, .reveal-right",
	);
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((e) => {
				if (e.isIntersecting) {
					e.target.classList.add("visible");
				}
			});
		},
		{ threshold: 0.15 },
	);
	revealEls.forEach((el) => observer.observe(el));

	// ===== Taxon cell mouse-tracking glow =====
	document.querySelectorAll(".taxon-cell").forEach((cell) => {
		cell.addEventListener("mousemove", (e) => {
			const rect = cell.getBoundingClientRect();
			const x =
				(((e.clientX - rect.left) / rect.width) * 100).toFixed(1) + "%";
			const y =
				(((e.clientY - rect.top) / rect.height) * 100).toFixed(1) + "%";
			cell.style.setProperty("--mx", x);
			cell.style.setProperty("--my", y);
		});
	});

	// ===== Subtle dew drip animations on hero plant (every few seconds) =====
	function triggerDewDrip() {
		const plant = document.querySelector(".hero-plant");
		if (!plant) return;
		const drops = plant.querySelectorAll(
			'circle[fill*="rgba(240,255,200"]',
		);
		if (drops.length === 0) return;
		const drop = drops[Math.floor(Math.random() * drops.length)];
		drop.style.transition = "r 0.3s ease";
		drop.setAttribute("r", "3");
		setTimeout(() => {
			drop.setAttribute("r", "1.5");
		}, 400);
		setTimeout(triggerDewDrip, 2200 + Math.random() * 1800);
	}
	setTimeout(triggerDewDrip, 2000);
}
